import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { animateScroll } from 'react-scroll';

import Accordion from 'components/Accordion';
import AccordionItem from 'components/Accordion/AccordionItem';
import { CategoryShape, TopicShape } from 'entities';
import quantity from 'quantity';
import { getCategories, getCategorySelected, getTopics } from 'selectors';
import * as actions from 'actions';

class ResourceCategoriesAccordion extends Component {

  constructor() {
    super();

    this.handleCategoryOpen = this.handleCategoryOpen.bind(this);
    this.countInfo = this.countInfo.bind(this);
    this.renderTopics = this.renderTopics.bind(this);

  }

  componentDidMount() {
    if(this.props.onDidMount) {
      this.props.onDidMount();
    }
  }

  componentWillUnmount() {
    if(this.props.onWillUnmount) {
      this.props.onWillUnmount();
    }
  }

  handleCategoryOpen(itemOffset) {
    const parentOffset = this.props.scrollElementGetter().offsetTop;
    animateScroll.scrollTo(itemOffset - parentOffset, { duration: 600 });
  }

  handleCategoryClick(category) {
    if(this.props.onCategoryClick) {
      this.props.onCategoryClick(category, this.props.selectedCategory);
    }
  }

  renderAccordionItemsForLoading() {
    return [
      <AccordionItem key="loader1" isEmpty />,
      <AccordionItem key="loader2" isEmpty />,
      <AccordionItem key="loader3" isEmpty />
    ];
  }

  renderTopics(category, topicsForSelectedCategory) {
    if (topicsForSelectedCategory.length > 0) {
      return topicsForSelectedCategory.map(topic => this.props.renderTopic(topic, this.countInfo));
    } else {
      return this.renderAccordionItemsForLoading();
    }
  }

  countInfo(categoryOrTopic) {
    const resourceCountInfo = `${categoryOrTopic.resourceCount} ${quantity(categoryOrTopic.resourceCount, this.props.resourceNameSingular, this.props.resourceNamePlural)}`;
    const usersCountInfo = `${categoryOrTopic.userCount} ${quantity(categoryOrTopic.userCount, __('entities.users.singular'), __('entities.users.plural'))}`;

    return `${resourceCountInfo} ${usersCountInfo}`;
  }

  renderCategories(selectedCategory, topicsForSelectedCategory) {
    return this.props.categories.map(category => {
      const shouldRenderTopics = selectedCategory && category.id == selectedCategory.id;
      const topics = shouldRenderTopics ? this.renderTopics(category, topicsForSelectedCategory) : [];

      return (
        <AccordionItem
          key={category.id}
          title={category.title}
          countInfo={this.countInfo(category)}
          onClick={() => this.handleCategoryClick(category)}
          isGroup
          onItemOpen={this.handleCategoryOpen}
          imageUrl={category.thumbnail.url}
          isExpanded={shouldRenderTopics}
          isForForum={this.props.isForForum}
          isForMagazine={this.props.isForMagazine}>

            {topics}

        </AccordionItem>
      );
    });
  }

  render() {
    return (
      <Accordion>
        {(() => {
          if(this.props.categories.length == 0) {
            return this.renderAccordionItemsForLoading();
          }

          return this.renderCategories(this.props.selectedCategory, this.props.topicsForSelectedCategory);
        })()}
      </Accordion>
    );
  }
}

ResourceCategoriesAccordion.propTypes = {
  categories: PropTypes.arrayOf(CategoryShape),
  selectedCategory: CategoryShape,
  topicsForSelectedCategory: PropTypes.arrayOf(TopicShape),
  renderTopic: PropTypes.func.isRequired,
  resourceType: PropTypes.string,
  resourceNameSingular: PropTypes.string,
  resourceNamePlural: PropTypes.string,
  isForForum: PropTypes.bool,
  isForMagazine: PropTypes.bool,
  scrollElementGetter: PropTypes.func,
  onCategoryOpen: PropTypes.func,
  onCategoryClick: PropTypes.func,
  onDidMount: PropTypes.func,
  onWillUnmount: PropTypes.func
};

const mapStateToProps = (state, props) => {
  const selectedCategory = getCategorySelected(state, props.resourceType);
  const topicsForSelectedCategory = selectedCategory ?
    getTopics(state, selectedCategory.id) :
    [];

  return {
    categories: getCategories(state),
    selectedCategory,
    topicsForSelectedCategory
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onDidMount: () => {
      dispatch(actions.categoriesFetch(props.resourceType));
    },
    onWillUnmount: () => {
      dispatch(actions.categorySelect(props.resourceType, null));
    },
    onCategoryClick: (category, selectedCategory) => {
      if(selectedCategory && category.id === selectedCategory.id) {
        dispatch(actions.categorySelect(props.resourceType, null));
      }
      else {
        dispatch(actions.categorySelect(props.resourceType, category.id));
        dispatch(actions.topicsFetch(props.resourceType, category.id));
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceCategoriesAccordion);



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/ResourceCategoriesAccordion/index.js
 **/